import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { LoggerService } from '../../../shared/logger.service';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { all } from '@awesome.me/kit-787edf9aa0/icons';
import { CasiEventService } from '../../casi-event.service';
import { Subscription } from 'rxjs';
import { User as UserModel } from '../../../models/models.lib';
import { TileItem } from '../../../common/obj.lib';

@Component({
  selector: 'app-test1',
  standalone: true,
  imports: [
    CommonModule,
    LayoutModule,
    ButtonsModule,
    IndicatorsModule,
    IconsModule,
    FormsModule,
    ReactiveFormsModule,
    DropDownsModule,
    FontAwesomeModule,
  ],
  templateUrl: './test1.component.html',
  styleUrl: './test1.component.scss'
})
export class Test1Component implements OnInit, OnDestroy, AfterContentInit {
  private _numberOfCols: number = 1;
  @Input()
  set numberOfCols(value: number) {
    this._numberOfCols = value;
  }
  get numberOfCols() {
    return this._numberOfCols;
  }

  private _tile: TileItem | undefined;
  @Input({ required: true })
  set tile(value: TileItem) {
    this.logger.debug(`set tile: `, value);
    this._tile = value;
  }
  get tile() {
    return this._tile!;
  }

  private _users: UserModel[] = [];
  @Input({ required: true }) set users(value: UserModel[]) {
    this.logger.debug(`set users: `, value);
    this._users = value;
  }
  get users() {
    return this._users;
  }

  private _subs: Subscription[] = [];

  constructor(
    private logger: LoggerService,
    public faIcons: FaIconLibrary,
    private casiEventService: CasiEventService
  ) {
    faIcons.addIcons(...all);
  }

  //#region Ng Event Handlers

  ngAfterContentInit(): void {
    this.logger.debug('ngAfterContentInit...');
  }
  ngOnDestroy(): void {
    this.logger.debug('ngOnDestroy...');
    this._subs.forEach(s => s.unsubscribe());
  }
  ngOnInit(): void {
    this.logger.debug('ngOnInit...', this);
    this._subs.push(this.casiEventService.casiEvent$.subscribe((e) => {
      this.logger.debug(`ngOnInit:casiEvent: `, e);
    }));
  }

  //#endregion
}
